import styleVariables from '../styles/variables.module.scss';

export function matchBreakpoint(id) {
  return window.matchMedia(`(min-width: ${styleVariables[`breakpoint-${id}`]})`);
}
